var map = {
	"./core": 324,
	"./core.js": 324,
	"./event": 326,
	"./event.js": 326,
	"./fake_server": 327,
	"./fake_server.js": 327,
	"./fake_server_with_clock": 328,
	"./fake_server_with_clock.js": 328,
	"./fake_timers": 329,
	"./fake_timers.js": 329,
	"./fake_xdomain_request": 331,
	"./fake_xdomain_request.js": 331,
	"./fake_xml_http_request": 332,
	"./fake_xml_http_request.js": 332,
	"./timers_ie": 333,
	"./timers_ie.js": 333,
	"./xdr_ie": 334,
	"./xdr_ie.js": 334,
	"./xhr_ie": 335,
	"./xhr_ie.js": 335
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib/sinon/util ^\.\/.*$
// module id = 325
// module chunks = 1